import React from 'react';
import { Box } from '@tanium/react-box';
import { ThemeSpace } from '@tanium/theme-data';
import { ContainerBorder, ContainerFill, ContainerShadow } from './themeDefinitions';

export interface Props {
  children: React.ReactNode;
}

export const QuickFilterContainer = ({ children }: Props) => (
  <Box
    px={ThemeSpace.minor[3]}
    py={1}
    backgroundColor={ContainerFill}
    boxShadow={ContainerShadow}
    borderRadius={1}
    border={1}
    borderColor={ContainerBorder}
  >
    {children}
  </Box>
);
